import { useParams, useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

interface NavigationContext {
  currentReceipt: {
    id: string;
    userId: string;
    path: string;
  } | null;
}

export const useNavigationContext = (): NavigationContext => {
  const { receiptId } = useParams<{ receiptId: string }>();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');

  return useMemo(() => {
    if (receiptId && userId) {
      return {
        currentReceipt: {
          id: receiptId,
          userId: userId,
          path: `/receipt/${receiptId}?userId=${userId}`
        }
      };
    }
    return { currentReceipt: null };
  }, [receiptId, userId]);
};
